<template>
    <div >
        <div class="ani" :style="{'opacity':loading?0:1}">
            <Carousel
                v-if="data.bannerImageList&&data.bannerImageList.length>0"
                v-model="banner"
                :loop="data.bannerImageList.length > 1"
                class="wh-auto oh banner auto wow fadeIn "
                arrow="never"
                autoplay
                :autoplay-speed="5000"
            >
                <CarouselItem v-for="(item, index) in data.bannerImageList" :key="index">
                    <img v-if="index===0" @load="banner_load_end" @error="banner_load_end" alt="" class=" wh-auto of-cv dis-block"  :src="item.path|img"/>
                    <img v-else alt="" class=" wh-auto of-cv dis-block" :src="item.path|img"/>
                </CarouselItem>
            </Carousel>
            <!--关于我们-->
            <div :class=" '  cr-white  ' + (scale_mob ? 'pd-t-40 pd-b-50' : 'pd-t-120 pd-b-140 content') " v-if="!hide_arr.includes('aboutUs')" >
                <div :class="'flex al-c' ">
                    <img
                        alt=""
                        :src="require('@/assets/images/about-us.png')"
                        :style="'width:' + (scale_ratio < 1 ? scale_ratio * 395 : 395) + 'px;'"
                        :class="scale_ratio < 1 ? 'pd-l-20' : ''"
                        class="wow fadeInLeft100"
                    />
                    <div :class="`flex-item  pd-r-20 `+(scale_mob?'pd-l-40':'pd-l-150')">
                        <div class="wow fadeInRight100">
                            <div
                                :class=" '  fw-b ' + (scale_mob ? 'txt-size-30 lh-30' : 'txt-size-50 lh-50') "
                            >
                                ABOUT US
                                <span class="bg-primary mr-l-5 rect-10 br-rad-4 dis-inline-block"></span>
                            </div>
                            <div
                                :class=" ' fw-b mr-t-30 ' + (scale_mob ? 'txt-size-22 lh-30' : 'txt-size-36 lh-36')"
                            >
                                关于我们
                            </div>
                        </div>
                        <div v-if="!scale_mob" class="wow fadeInRight100" data-wow-delay="0.2s">
                            <div class="lh-24 html-wrap mr-t-60 op-80" v-html="get_text_html(data.aboutUs,10)"></div>
                            <component-more-btn class="mr-t-50" name="introduce"></component-more-btn>
                        </div>
                    </div>
                </div>
                <div class="pd-h-30 wow fadeInUp100" data-wow-delay="0.2s" v-if="scale_mob">
                    <div :class="' mr-t-30 op-80 txt-size-12 lh-20' ">
                        <div class="lh-20 html-wrap txt-size-12 mr-t-60 op-80" v-html="get_text_html(data.aboutUs,10)"></div>
                    </div>
                    <component-more-btn class="mr-t-20" name="introduce"></component-more-btn>
                </div>
            </div>
            <!--业务-->
            <div v-if="!hide_arr.includes('business')">
                <div class="oh" v-if="scale_mob">
                    <div
                        class="w-50 fl pr business-item cp wow zoomIn"
                        v-for="(item, index) in data.businessList"
                        :key="index"
                        @click="click_business(item)"
                    >
                        <img
                            alt=""
                            :src="$static_url+item.images[0].path"
                            class="wh-auto h-min-360 of-cv dis-block"
                        />
                        <div class="pa-c tc cr-white wh-auto pd-h-20">
                            <div class="rect-100 pr auto mr-b-10 ani business-icon">
                                <img
                                    alt=""
                                    class="pa-lt wh-auto ht-auto"
                                    :src="$static_url+item.images[1].path"
                                />
                            </div>
                            <div class="txt-size-18 lh-30 pd-b-10">{{ item.title }}</div>
                        </div>
                    </div>
                    <div
                        class="w-50 fl pr business-item cp h-120 bg-primary wow zoomIn"
                        @click="click_business(data.businessList[0])"
                    >
                        <div class="pa-c tc cr-white wh-auto pd-h-20">
                            <div class="txt-size-18 lh-30 ">查看更多 ></div>
                        </div>
                    </div>
                </div>
                <div class="oh pr pd-r-60" v-else>
                    <div class="pa-rt ht-auto bg-gray flex cr-white flex-c al-c cp jc-c ani bg-hover wow fadeInRight"
                         data-wow-delay="0.4s"
                         @click="click_business(data.businessList[0])"
                         style="width: 60px;">
                        <div class="txt-size-18" v-for="item in ['查','看','更','多',]">{{item}}</div>
                    </div>
                    <div
                        class=" fl pr business-item cp wow fadeInUp100"
                        :data-wow-delay="`0.${index}s`"
                        :style="`width:${(100/data.businessList.length)}%`"
                        v-for="(item, index) in data.businessList"
                        :key="index"
                        @click="click_business(item)"
                    >
                        <img
                            alt=""
                            :src="$static_url+item.images[0].path"
                            class="wh-auto h-min-720 of-cv dis-block"
                        />
                        <div class="pa-c">
                            <div class="tc cr-white" :style="`transform:scale(${scale_ratio}) `">
                                <div class="rect-100 pr auto mr-b-10 ani business-icon">
                                    <img
                                        alt=""
                                        class="pa-lt wh-auto ht-auto of-ct ani img-hover"
                                        :src="$static_url+item.images[1].path"
                                    />
                                    <img
                                        alt=""
                                        class="pa-lt wh-auto ht-auto of-ct ani img-hover-s"
                                        :src="$static_url+item.images[2].path"
                                    />
                                </div>
                                <div class="txt-size-30 lh-30  pd-b-20">{{ item.title }}</div>
                                <div class="text-hover ani txt-size-16 lh-26 w-220" style="height: 52px">
                                    {{ item.descript }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--项目案例-->
            <div class="pr" :class="scale_mob ? ' pd-v-20' : 'pd-t-140  pd-b-60'" v-if="!hide_arr.includes('case_data')">
                <div class="content pd-h-20 wow fadeInRight100" >
                    <div :class=" ' fw-b cr-white ani ' + (scale_mob ? 'txt-size-30 lh-30' : 'txt-size-50 lh-50') " >
                        PROJECT CASE
                        <span class="bg-primary mr-l-5 rect-10 br-rad-4 dis-inline-block"></span>
                    </div>
                    <div class="flex al-c jc-sb ani mr-t-30">
                        <div :class=" '  fw-b cr-white ' + (scale_mob ? 'txt-size-22 lh-30' : 'txt-size-36 lh-36') " >
                            项目案例
                        </div>
                        <div class="oh ">
                            <div class="swiper-prev ani fl rect-44 mr-r-20 bg-gray flex jc-c al-c cp cr-gray-999" >
                                <Icon class="icon txt-size-24 " type="ios-arrow-back"/>
                            </div>
                            <div class="swiper-next ani fl rect-44 bg-gray flex jc-c al-c cp cr-gray-999">
                                <Icon class="icon txt-size-24 " type="ios-arrow-forward"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper2 pr wh-auto mr-t-60 wow fadeInRight100" data-wow-delay="0.2s">
                    <div class="wh-auto ht-auto oh swiper-container" ref="mySwiper">
                        <div class="swiper-wrapper">
                            <div :class="'swiper-slide pr pd-h-20 '"
                                 :style="`width:${scale_ratio<1?1300*scale_ratio:1300}px;height:${scale_ratio<1?560*scale_ratio:560}px;`"
                                 @click="click_case(item,i)"
                                 v-for="(item, i) in data.projectCaseList" :key="i" >
                                <img class="dis-block wh-auto ht-auto of-cv"
                                     v-if="item.coverImage&&item.coverImage.length>0"
                                     :src="item.coverImage|img" alt=""/>
                                <div class="wh-auto ht-auto pd-h-20 pa-lt">
                                    <div class="mask bg-black ani op-60  wh-auto ht-auto "></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wh-auto mr-b-30 mr-t-40 swiper-container wow fadeIn" data-wow-delay="0.4s" ref="mySwiper_txt">
                    <div class="swiper-wrapper">
                        <div
                            class="swiper-slide pd-h-20 cr-white tc"
                            v-for="(item, i) in data.projectCaseList"
                            :key="i"
                        >
                            <div class="dis-inline-block" @click="click_case(item,i)">
                                <div class="tc fw-b mr-b-20" :class="scale_ratio < 1 ? ' txt-size-18 lh-24' : 'txt-size-24 lh-30'" >
                                    {{ item.title }}
                                </div>
                                <div class="tc op-80 html-wrap w-max-660 auto " :class="scale_ratio < 1 ? ' txt-size-12 lh-22' : 'content txt-size-14 lh-24'"
                                     v-html="get_text_html(item.copywritingContent,0)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pr wow zoomIn" data-wow-delay="0.4s" style="height: 20px">
                    <div class="swiper-pagination wh-auto ht-auto"></div>
                </div>
            </div>
            <!--新闻中心-->
            <div class="pr"  v-if="!hide_arr.includes('news')">
                <div :class="' ht-auto wh-auto pa-lt ' + (scale_ratio < 1 ? 'bg-p-c' : 'news-bg')"
                     :style="`background-image: url(${require('@/assets/images/home-news-bg.jpg')})`"
                ></div>
                <div class="content pr pd-h-20" :class="scale_ratio < 1 ? ' pd-v-40' : 'pd-t-60 pd-b-40'" >
                    <div class="wow fadeIn">
                        <div :class=" ' fw-b cr-white ani ' + (scale_mob ? 'txt-size-30 lh-30' : 'txt-size-50 lh-50') "
                        >
                            NEWS CENTER
                            <span class="bg-primary mr-l-5 rect-10 br-rad-4 dis-inline-block"></span>
                        </div>
                        <div class="flex al-c jc-sb ani mr-t-30 "  >
                            <div :class=" '  fw-b cr-white ' + (scale_mob ? 'txt-size-22 lh-30' : 'txt-size-36 lh-36') " >
                                新闻中心
                            </div>
                            <component-more-btn name="news"></component-more-btn>
                        </div>
                    </div>
                    <div class=" mr-t-50" v-if="data.newsTrendList&&data.newsTrendList.length>0">
                        <div class="fl news-left effect wow fadeInLeft100" v-if="scale_ratio >= 1" @click="click_news(data.newsTrendList[0])">
                            <div class="news-img wh-auto mr-b-20 oh">
                                <img class="wh-auto ht-auto of-cv" alt="" :src="data.newsTrendList[0].path|img" />
                            </div>
                            <div class="cr-white-t mr-b-10">{{ data.newsTrendList[0].publishDate }}</div>
                            <div class="cr-white txt-size-18 lh-28 mr-b-10 title ani ">{{data.newsTrendList[0].title}}</div>
                            <div class="multi-text cr-white-t lh-24">{{data.newsTrendList[0].briefContent}}</div>
                        </div>
                        <div :class="'wow fadeInRight100 ' + (scale_ratio < 1 ? ' ' : 'fr news-right')">
                            <div class="flex mr-b-40 effect" v-if="scale_ratio < 1" @click="click_news(data.newsTrendList[0])">
                                <div class="news-img-small">
                                    <img alt="" :src="data.newsTrendList[0].path|img" class="wh-auto ht-auto of-cv" />
                                </div>
                                <div class="flex-item pd-l-30">
                                    <div class="cr-white-t mr-b-10">{{ data.newsTrendList[0].publishDate }}</div>
                                    <div class="cr-white multi-text title ani"
                                         :class=" scale_ratio < 1 ? 'txt-size-14 lh-24 mr-b-5' : 'txt-size-18 lh-28 mr-b-10' "
                                    >
                                        {{data.newsTrendList[0].title}}
                                    </div>
                                    <div :class=" 'multi-text cr-white-t  ' + (scale_ratio < 1 ? 'txt-size-12 lh-18' : 'lh-24') "
                                    >
                                        {{data.newsTrendList[0].briefContent}}
                                    </div>
                                </div>
                            </div>
                            <div :class="'flex  effect wow fadeInRight100 '+(index!==2?'mr-b-40':'') "
                                 :data-wow-delay="`0.${index+1}s`"
                                 v-for="(item,index) in data.newsTrendList.slice(1,4)"
                                 :key="index" @click="click_news(item)">
                                <div class="news-img-small oh">
                                    <img alt="" :src="item.path|img" class="wh-auto ht-auto of-cv" />
                                </div>
                                <div class="flex-item pd-l-30">
                                    <div class="cr-white-t mr-b-10">{{item.publishDate}}</div>
                                    <div :class="'cr-white ani title multi-text '+(scale_ratio<1?'txt-size-14 lh-24 mr-b-5':'txt-size-18 lh-28 mr-b-10')">
                                        {{item.title}}
                                    </div>
                                    <div :class=" 'multi-text cr-white-t  ' + (scale_ratio < 1 ? 'txt-size-12 lh-18' : 'lh-24') " >
                                        {{item.briefContent}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cb"></div>
                    </div>
                </div>
            </div>
            <!--合作伙伴-->
            <div class="pr" :class="scale_ratio < 1 ? 'pd-v-40' : 'pd-v-100'" v-if="!hide_arr.includes('businessPartner')">
                <img
                    alt=""
                    class="ht-auto wh-auto of-cv pa-c w-max-1920"
                    :src="require('@/assets/images/partners-bg.png')"
                />
                <div
                    class="content pr pd-l-20 h-min-260"
                    :class="scale_ratio < 1 ? ' pd-h-20' : 'flex al-c jc-sb'"
                >
                    <div class="cr-white wow fadeInLeft100" :class="scale_ratio < 1 ? 'mr-b-30' : ''">
                        <div :class=" ' fw-b cr-white ani ' + (scale_mob ? 'txt-size-30 lh-30' : 'txt-size-50 lh-50') " >
                            PARTNERS
                            <span class="bg-primary mr-l-5 rect-10 br-rad-4 dis-inline-block"></span>
                        </div>
                        <div class="flex al-c jc-sb ani mr-t-30">
                            <div :class=" '  fw-b cr-white ' + (scale_mob ? 'txt-size-22 lh-30' : 'txt-size-36 lh-36') " >
                                合作伙伴
                            </div>
                        </div>
                    </div>
                    <div
                        class="oh  wow fadeInRight100 "
                        :class="scale_mob ? 'flex jc-sb flex-w' : 'pd-h-10'"
                        :style="`width: ${scale_ratio < 1 ? '100%' : '850px'};`"
                        v-if="data.businessPartner&&data.businessPartner.length>0"
                    >
                        <div
                            class="bg-gray bg-nr fl mr-b-20 bg-p-c flex al-c jc-c effect"
                            :class="scale_mob ? 'partners-mob h-80' : 'partners-pc h-120 mr-h-10'"
                            v-for="(item, index) in data.businessPartner"
                            :key="index"
                            :style="`background-image: url(${$static_url+item.path})`"
                        >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pf rect-80" style="top:50%;left: 50%;transform: translate(-50%,-50%);" v-if="loading">
            <component-loading></component-loading>
        </div>
    </div>
</template>
<script>
import componentMoreBtn from '@/components/more-btn/more-btn.vue';
import 'swiper/css/swiper.css';
import Swiper from 'swiper'; //引入swiper插件
import WOW from 'wowjs';
import ComponentLoading from '@/components/loading/loading.vue';
export default {
    components: {ComponentLoading, componentMoreBtn},
    data() {
        return {
            loading:true,
            mySwiper_txt: null,
            mySwiper: null,
            banner: 0,
            data:{},
            hide_arr:[],
        };
    },
    computed: {
        scale_ratio: function () {
            return Number(this.$store.state.system.scale_ratio);
        },
        scale_mob: function () {
            return this.$store.state.system.scale_mob;
        },
    },
    watch: {
        scale_mob() {
            this.$nextTick(() => {
                this.mySwiper.update();
            });
        }
    },
    methods: {
        banner_load_end(){
            this.$nextTick(()=>{
                this.set_swiper();
                let wow = new WOW.WOW({
                    boxClass: "wow",
                    animateClass: "animated",
                    offset: 60,
                    mobile: true,
                    live: false,
                    scrollContainer:'#app'
                });
                wow.init();
                setTimeout(()=>{
                    this.loading = false;
                },50)
            })
        },
        /**
         *@Description 获取数据
         *@author liujiaji
         */
        get_data(){
            const params = {}
            this.$api.post('/page/getHomePageInfo',params).then(res=>{
                if (res.status === 200) {
                    const data = res.data;
                    this.data = data;
                    this.hide_arr = data.hideInfo||[];
                }
            })
        },

        /**
         *@Description 跳转业务模块
         *@param item 业务数据
         *@author liujiaji
         */
        click_business(item){
            const url_params = {
                name:'service',
                query:{
                    id:item.id
                }
            }
            const {href} = this.$router.resolve(url_params);
            window.open(href, '_blank'); //打开新的窗口
        },
        click_news(e){
            const url_params = {
                name: 'news-detail',
                query:{
                    id:e.id
                }
            }
            const {href} = this.$router.resolve(url_params);
            window.open(href, '_blank'); //打开新的窗口
        },
        /**
         *@Description 点击案例图片,点击当前页跳转详情，其他则切换点击页，不跳转
         *@param e 点击对象数据
         *@param index 点击对象索引
         *@author liujiaji
         */
        click_case(e,index){
            if(this.mySwiper.activeIndex === index){
                const url_params = {
                    name: 'case-detail',
                    query:{
                        id:e.id
                    }
                }
                const {href} = this.$router.resolve(url_params);
                window.open(href, '_blank'); //打开新的窗口
            }else{
                this.mySwiper.slideTo(index);
            }
        },
        set_swiper(){
            const _this = this;
            // 创建Swiper实例
            this.mySwiper_txt = new Swiper(this.$refs.mySwiper_txt, {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                allowTouchMove: false
            });
            // 创建Swiper实例
            this.mySwiper = new Swiper(this.$refs.mySwiper, {
                speed: 1000,
                autoplayDisableOnInteraction: false,
                centeredSlides: true,
                slidesPerView: 'auto',
                paginationClickable: true,
                autoplay: {
                    delay: 30000,
                    stopOnLastSlide: false,
                    pauseOnMouseEnter: true,
                },
                pagination: {
                    el: '.swiper-pagination'
                },
                navigation: {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev'
                },
                controller: {
                    control: this.mySwiper_txt //控制Swiper1
                }
            });
            this.mySwiper.el.onmouseover = function(){
                _this.mySwiper.autoplay.stop();
            }
            this.mySwiper.el.onmouseout = function(){
                _this.mySwiper.autoplay.start();
            }
        }
    },
    created() {
        this.get_data();
    },
    mounted() {
    }
};
</script>
<style lang="less" scoped>


.partners-pc {
    width: 187px;
}

.partners-mob {
    width: ~'calc(50% - 10px)';
}

.banner {
    /deep/ .ivu-carousel-dots {
        left: 0;
        bottom: 5%;
        .ivu-carousel-active button {
            background: @color_primary;
        }
    }
}
.business-item {
    .img-hover-s {
        opacity: 0;
    }

    .text-hover {
        transform: translateY(-10px);
        opacity: 0;
    }

    &:hover {
        .business-icon {
            transform: scale(1.05);
        }
        .img-hover {
            opacity: 0;
        }
        .img-hover-s {
            opacity: 1;
        }

        .text-hover {
            opacity: 1;
            transform: translateY(0px);
        }
    }
}

.news {
    &-bg {
        background-repeat: no-repeat;
        background-position: right top;
        background-size: cover;
    }

    &-left {
        width: 560px;
    }

    &-right {
        width: 600px;
    }

    &-img {
        height: 320px;
    }

    &-img-small {
        width: 160px;
        height: 120px;
    }
}
.qh{
    &-bg{
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
    }
}
.swiper2 {
    .swiper-slide-active,
    .swiper-slide-duplicate-active {
        .mask {
            opacity: 0;
        }
    }
}

/deep/ .swiper-pagination-bullet {
    background: #fff;
    margin: 0 5px;

    &.swiper-pagination-bullet-active {
        background: @color_primary;
    }
}

</style>
